module.exports = __webpack_public_path__ + "media/images/creator/home/kv@2x-3b926977250142c2614f628c9728729f.png";